import { Users, FileCheck, Clock, Award } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { useTranslation } from "react-i18next";

export const WhyChooseUs = () => {
  const { t } = useTranslation();

  const reasons = [
    {
      icon: <Users className="w-12 h-12 text-[#bc943e]" />,
      title: t("whyChooseUs.reasons.expertTeam.title"),
      description: t("whyChooseUs.reasons.expertTeam.description")
    },
    {
      icon: <FileCheck className="w-12 h-12 text-[#bc943e]" />,
      title: t("whyChooseUs.reasons.highSuccessRate.title"),
      description: t("whyChooseUs.reasons.highSuccessRate.description")
    },
    {
      icon: <Clock className="w-12 h-12 text-[#bc943e]" />,
      title: t("whyChooseUs.reasons.quickResponse.title"),
      description: t("whyChooseUs.reasons.quickResponse.description")
    },
    {
      icon: <Award className="w-12 h-12 text-[#bc943e]" />,
      title: t("whyChooseUs.reasons.provenTrackRecord.title"),
      description: t("whyChooseUs.reasons.provenTrackRecord.description")
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12 text-[#bc943e]">
          {t("whyChooseUs.title")}
        </h2>
        <div className="grid md:grid-cols-4 gap-8">
          {reasons.map((reason, index) => (
            <Card key={index} className="border-none shadow-lg">
              <CardContent className="p-6 text-center">
                <div className="flex justify-center mb-4">{reason.icon}</div>
                <h3 className="text-xl font-semibold mb-2 text-gray-800">{reason.title}</h3>
                <p className="text-gray-600">{reason.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};